import { User } from "..";
import { PasswordResetRequestStatus } from "../enumerations";

export class PasswordResetRequest {
	public static readonly $type: string = "PasswordResetRequest";
	public readonly $type: string = PasswordResetRequest.$type;

	public token!: string;
	public status!: PasswordResetRequestStatus;
	public date!: Date;
	public user!: User;

}
